import React, { useState, useMemo } from "react";
import CustomTab from "@/components/dataTableComponents/CustomTab";
import CustomCard from "@/pages/leave/components/CustomCard";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable"; // Assuming this is your table component
import DoneOutlined from "@mui/icons-material/DoneOutlined";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";
import StyledBadge from "@/components/badge/Badge";
import { Tooltip, Button, Box, Typography, Divider, } from "@mui/material";
import CustomAlert from "@/components/alert/CustomAlert";
import DialogForm from "@/pages/leave/components/DialogForm";
import DialogFormModal from "@/components/modal/DialogForm";


import VisibilityIcon from '@mui/icons-material/Visibility';

// import { useFetchLeaveApproveQuery, useFetchLeaveApproveCompletedQuery, usePostLeaveApproveMutation, usePostLeaveApproveRejectMutation } from "@/api/services/leave/LeaveApprove";
import { toast } from "@/components/toastify";
import { useGetOnSiteApprovalsQuery, useApproveOnSiteMutation } from "@/api/services/attendance/approvals/Approvals";

const OnsiteApprovals = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [selectedLeaveDetails, setSelectedLeaveDetails] = useState(null);
    const [openLeaveDetailsDialog, setOpenLeaveDetailsDialog] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [approveOnSite] = useApproveOnSiteMutation();
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(1);

    const {
        data: leaveApproveData,
        isLoading: leaveApproveLoading,
        isError: leaveApproveError,
    } = useGetOnSiteApprovalsQuery(
        { key: "Pending" },
    );

    const {
        data: leaveApproveCompleted,
        isLoading: leaveApproveCompletedLoading,
        isError: leaveApproveCompletedError,
    } = useGetOnSiteApprovalsQuery(
        { key: "Approved" },

    );

    const rows = activeTab === 0 ? leaveApproveData?.data?.users || [] : leaveApproveCompleted?.data?.users || [];

    // const rows = [{ "empId": "901568", 
    //     "approverId": "900581", 
    //     "totalWorkHours": "09:08", 
    //     "approverName": "Sugumar V", 
    //     "inTime": "08:18:15", 
    //     "excessHours": "00:08", 
    //     "leaveType": "Pending", 
    //     "month": "08-2025", 
    //     "leave": ["OD", "WFH"], 
    //     "empName": "Rajesh P", 
    //     "actualWorkHours": "09:00", 
    //     "shortfallHours": "00:00:00", 
    //     "attendanceData": "P", 
    //     "attendanceDate": "2025-08-06", 
    //     "outTime": "17:26:38", 
    //     "status": "Pending" }]

    const tabsData = [
        { name: "Pending", count: leaveApproveData?.data?.length || 0 },
        { name: "Approved", count: leaveApproveCompleted?.data?.length || 0 },
    ];

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setPage(1);
    };

    const ActionButtons = ({ row, onViewClick, onApproveClick, onRejectClick }) => (
        <div>
            {/* <Tooltip title="View">
        <RemoveRedEyeOutlined
          onClick={() => onViewClick(row)}
          style={{ cursor: "pointer", marginRight: 8 }}
        />
      </Tooltip> */}
            <Tooltip title="Approve">
                <DoneOutlined
                    onClick={() => onApproveClick(row)}
                    style={{ cursor: "pointer", marginRight: 8 }}
                />
            </Tooltip>
            <Tooltip title="Reject">
                <CloseOutlined
                    onClick={() => onRejectClick(row)}
                    style={{ cursor: "pointer" }}
                />
            </Tooltip>
        </div>
    );

    const handleViewClick = (row) => {
        setOpenLeaveDetailsDialog(true);
        setSelectedLeaveDetails(row);
    };

    const handleApproveClick = (row) => {
        setOpenApprovePopUp(true);
        setRowData(row);
    };

    const handleRejectClick = (row) => {
        setOpenDialog(true);
        setRowData(row);
    };

    const columns = useMemo(() => {
        return activeTab === 1
            ? [
                { field: "empName", headerName: "Name", flex: 1 },
                // { field: "empId", headerName: "Employee ID", flex: 1 },
                { field: "leave", headerName: "Category", renderCell: (params) => params.value.join(", "), flex: 1 },
                { field: "approverName", headerName: "Approved By", flex: 1 },
                {
                    field: "attendanceDate",
                    headerName: "Date", flex: 1
                },
                {
                    field: "inOutTime",
                    headerName: "IN/OUT Time",
                    renderCell: (params) => `${params.row.inTime} - ${params.row.outTime}`, flex: 1
                },
                { field: "totalWorkHours", headerName: "Total Work Hrs", flex: 1 },
                {
                    field: "leaveType",
                    headerName: "Status",

                    renderCell: (params) => (
                        <StyledBadge
                            name={params.value}
                            status={params.value === "Approved"}
                            chipBgColor={params.value === "Approved" ? "#ECFDF3" : "#FEF3F2"}
                            labelColor={params.value === "Approved" ? "#067647" : "#B42318"}
                        />
                    ), flex: 1
                },
            ]
            : [
                {
                    field: "action",
                    headerName: "Action",
                    renderCell: (params) => (
                        <ActionButtons
                            row={params.row}
                            //   onViewClick={handleViewClick}
                            onApproveClick={handleApproveClick}
                            onRejectClick={handleRejectClick}
                        />
                    ), flex: 1
                },
                { field: "empName", headerName: "Name", flex: 1 },
                // { field: "empId", headerName: "Employee ID", flex: 1 },
                { field: "leave", headerName: "Category", renderCell: (params) => params.value.join(", "), flex: 1 },
                { field: "approverName", headerName: "Pending With", flex: 1 },
                { field: "attendanceDate", headerName: "Date", flex: 1 },
                {
                    field: "inOutTime",
                    headerName: "IN/OUT Time",
                    renderCell: (params) => `${params.row.inTime} - ${params.row.outTime}`, flex: 1
                },
                { field: "totalWorkHours", headerName: "Total Work Hrs", flex: 1 },
                
            ];
    }, [activeTab, rows]);

    const renderContent = () => (
        <CommonDataTable
            columns={columns}
            rows={rows}
            searchBar={true}
            search={true}
            checkbox={false}
            loading={leaveApproveLoading || leaveApproveCompletedLoading}
        />
    );

    const [openApprovePopUp, setOpenApprovePopUp] = useState(false);
    const approveClose = () => setOpenApprovePopUp(false);

    const handleApprovePopUpSubmit = async () => {
        try {
            setOpenApprovePopUp(false);
            const status = "Approved";
            const empId = rowData?.empId;
            const date = rowData?.attendanceDate;
            const month = rowData?.month;
            // console.log(status, empId, date, month);
            await approveOnSite({ status, empId, date, month });
            toast("success", "Approved successfully");
        } catch (error) {
        }
    };

    const fields = [
        {
            name: "reason",
            label: "Reason",
            type: "textarea",
            required: true,
            validationMessage: "Reason is required",
            placeholder: "Enter Reason",
            fullWidth: true,
        },
    ];

    const [openDialog, setOpenDialog] = useState(false);
    const handleSubmit = async (formData) => {
        try {
            const data = {};
            formData?.forEach?.((value, key) => {
                data[key] = value;
            });

            setOpenDialog(false);

            const status = "Rejected";
            const empId = rowData?.empId;
            const date = rowData?.attendanceDate;
            const month = rowData?.month;
            const reason = data?.reason;
            // console.log(status, empId, date, month, reason);
            await approveOnSite({ status, empId, date, month, reason });
            toast("success", "Rejected successfully");
        } catch (error) {
        }
    };

    const buttons = [
        { type: "cancel", label: "Cancel", size: "medium", variant: "outlined" },
        { type: "submit", label: "Submit", size: "medium", variant: "contained" },
    ];

    return (
        <>
            <CustomCard
                headers={["Onsite Approval"]}
                customTab={
                    <CustomTab
                        tabs={tabsData}
                        value={activeTab}
                        renderContent={renderContent()}
                        onChange={handleTabChange}
                    />
                }
            />
            <CustomAlert
                open={openApprovePopUp}
                title="Approval Request"
                message="Are you sure, you want to approve this application?"
                onCancel={approveClose}
                onSubmit={handleApprovePopUpSubmit}
                cancelText="Cancel"
                submitText="Submit"
            />
            <DialogForm
                fields={fields}
                title="Reject Request"
                handleSubmit={handleSubmit}
                open={openDialog}
                setOpen={setOpenDialog}
                buttons={buttons}
                component="LeaveBalance"
                message={"Are you sure, you want to reject this request?"}
            />

        </>
    );
};

export default OnsiteApprovals;
